import http from '../utils/http-common'

const getAll = (param, cancelToken) => {
  return http.get('/reports', { params: param, cancelToken: cancelToken?.token })
}

const get = (id) => {
  return http.get(`/report/${id}`)
}

const update = (id, data) => {
  return http.put(`/reports/${id}`, data)
}

const exportReport = (id, param) => {
  return http.get(`/reports/export/${id}`, { params: param })
}

const getReportTypes = () => {
  return http.get('/report-types')
}

const ReportDataService = {
  getAll,
  get,
  update,
  exportReport,
  getReportTypes,
}
export default ReportDataService
